import React from "react";
import { observer } from "mobx-react";
import { MrbApp } from "mrb/core";
import { ApplicationLocalization, localizationService } from "common/localization";
import { AppStartupLoader } from "common/components";
import MobxReactFormDevTools from "mobx-react-form-devtools";

@observer
class App extends React.Component {
    render() {
        return (
            <React.Fragment>
                <ApplicationLocalization {...this.props} localizationService={localizationService}>
                    {(props) => <MrbApp {...props} loaderRenderer={() => <AppStartupLoader />} />}
                </ApplicationLocalization>
                {process.env.NODE_ENV === "development" && <MobxReactFormDevTools.UI />}
            </React.Fragment>
        );
    }
}

export default App;
